var header4i = function() {
	var animate = animations4i();
	var userLinksWrapper = document.getElementById("userSpecificLinksBox");
	var mobileLink = document.getElementById("mobileLink");
	var chatLink = document.getElementById("initChat");
	var callWrapper = document.getElementsByClassName("callWaitWrapper")[0],

	showMobileLink = function() {
		if(window.location.hostname.indexOf("m.4imprint.") < 0 && window.location.hostname.indexOf("mobiledev.4imprint.") < 0 && mobileLink !== null) {
			var mobileRequest = ajax({
				method: "GET",
				url: '/Header/IsMobileDevice'
			});
			mobileRequest.then(function(response, xhr){
				mobileLink.innerHTML = response;
				mobileLink.classList.add("show");
			});
		}
	},
	loadCallStats = function() {
		if (callWrapper == null) { return; }
		var callWaitRequest = ajax({
			method: "GET",
			url: '/Header/CallWaitTime',
			timeout: 20000
		});
		callWaitRequest.then(function(response, xhr){
			callWrapper.classList.add("hide");
    			callWrapper.classList.remove("hideOnMedium");
    			callWrapper.insertAdjacentHTML('afterend', response); 
		});
	},
	loadUserLinks = function() {	
		var userLinksRequest = ajax({
			method: "GET",
			url: '/Header/UserSpecificLinks',
			timeout: 20000
		});
		userLinksRequest.then(function(response, xhr){
			if (userLinksWrapper == null) { return; }
	    		userLinksWrapper.innerHTML = response;
			init_mobileSearch();
			init_accountsummary();
			init_cartsummary();
			init_seooverlay();
		});
	},
	init_seooverlay = function() {
		var _saveSeo = function(){
			var seoData = {"Url": window.location.pathname, "PageTitle": document.getElementById('seoTitle').value, "MetaDescription": document.getElementById('seoMeta').value }
			var seoUpdateRequest = ajax({
				url: '/SeoOverlay/SetSeoData',
				method: "POST",
				data:  seoData,
				contentType: "application/json",
				timeout: 20000
			});
			seoUpdateRequest.then(function(response, xhr){
				if(response.success === 'true'){
					document.getElementById('seoResults').innerHTML = "Success! " + response.message;
				}else{
					document.getElementById('seoResults').innerHTML = "Failed: " + response.message;
				}
			});
		}
		var _fillSeo = function(){
			
			document.getElementById('seoTitle').value = document.title;
			document.getElementById('seoMeta').value = document.querySelector("meta[name='description']").getAttribute('content');
		
		}
		
		var seoBtn = document.getElementById('seoBtn');
		seoBtn && seoBtn.addEventListener("click", function (e) {
		
			if(document.getElementById('seoOverlay')){
				//removes overlay
				var seoSave = document.getElementById('seoSave');
				seoSave.removeEventListener('click', _saveSeo);
				var seoFill = document.getElementById('seoFill');
				seoFill.removeEventListener("click", _fillSeo);
				document.getElementById('seoOverlay').remove();
				document.getElementsByClassName('HeaderPhone')[0].style.display = "block";
			}else{
				// creates overlay
				var urlData = {"url": window.location.pathname };		
				var getOverlayRequest = ajax({
					url: '/SeoOverlay/GetOverlay',
					method: "GET",
					data: urlData,
					contentType: "application/json",
					timeout: 20000
				});
				getOverlayRequest.then(function(response, xhr){
					var seoContainer = document.createElement("div");
					seoContainer.setAttribute("id", "seoOverlay");

					document.getElementsByClassName('HeaderPhone')[0].style.display = "none";
					seoContainer.innerHTML = response;
					
					document.getElementsByTagName("body")[0].prepend(seoContainer);
					var seoSave = document.getElementById('seoSave');
					seoSave && seoSave.addEventListener("click", _saveSeo);
					var seoFill = document.getElementById('seoFill');
					seoFill && seoFill.addEventListener("click", _fillSeo);
					
					var seoLd = document.querySelectorAll('script[type="application/ld+json"]');
					if(seoLd)
					{
						for (var x = 0; x < seoLd.length; x++){
						    document.getElementById('seoJsonLd').innerHTML += seoLd[x].text;
						}
					}
					
					var seoTitle = document.getElementById('seoTitle');
					if(seoTitle && seoTitle.value ===''){
						seoTitle.value = document.title;
					}
					
					var seoMeta = document.getElementById('seoMeta');
					
					if(seoMeta && seoMeta.value === ''){
						seoMeta.value = document.querySelector("meta[name='description']").getAttribute('content');
					}
	
				});			
			}
			
		});
	},
	init_mobileSearch = function() {
		var mobileSearch = document.getElementById("showMobileSearch");
		var searchInput = document.getElementById("txtSearch");
		if (mobileSearch !== null){
			mobileSearch.addEventListener("click", function(){
				var searchBar = document.getElementsByClassName("HeaderSearchBar")[0];
				if(searchBar.classList.contains("show")){
					searchBar.classList.remove("show");
					searchBar.classList.add("hide");
					mobileSearch.classList.remove("bkgdLtGray");
					mobileSearch.setAttribute("aria-expanded", "false");
					mobileSearch.focus();
				}else{
					searchBar.classList.remove("hide");
					searchBar.classList.add("show");
					mobileSearch.classList.add("bkgdLtGray");
					mobileSearch.setAttribute("aria-expanded", "true");
					searchInput.focus();
				}
			});
		}
	},
	init_accountsummary = function() {
		var accountTrigger = document.getElementById("accountTrigger");
		hoverintent(accountTrigger, 
			function(){ showAccountView(); }, 
			function(){ hideAccountView(); }
		);
		accountKeys();
	},
	showAccountView = function(trigger, menu) {
		var accountView = document.getElementById("accountMenu");
		var accountLink = document.getElementById("lnkAccountSummary");
		accountView.style.display = "block";
		animate.slideDown(accountView);
		accountLink.setAttribute("aria-expanded", "true");
		document.removeEventListener("keydown", escapeCart);
		document.addEventListener("keydown", escapeAccount);
	},
	escapeAccount = function(e){
    		if((e.which || e.keyCode) === 27){ // allow user to close on escape
			hideAccountView();
    		}
	},
	hideAccountView = function() {
		var accountView = document.getElementById("accountMenu");
		var accountLink = document.getElementById("lnkAccountSummary");
		animate.slideUp(accountView);
		setTimeout(function(){
			//accountView.style.display = "none";
			accountLink.setAttribute("aria-expanded", "false");
		}, 200);
	},
	init_cartsummary = function() {
		var cartTrigger = document.getElementById("cartTrigger");
	    	hoverintent(cartTrigger, 
			function(){ showCartView(); }, 
			function(){ hideCartView(); }
		);    
		cartKeys();
	},
	showCartView = function() {
		var cartView = document.getElementsByClassName("cartsummary_view")[0];
		var cartSummary = document.getElementById("lnkCartSummary");
		//cartView.classList.add('showing');  // is this needed?
		cartView.style.display = "block";
		animate.slideDown(cartView);
		cartSummary.setAttribute("aria-expanded", "true");
		lazyloadImages.update();
		document.removeEventListener("keydown", escapeAccount);
		document.addEventListener("keydown", escapeCart);
	},
	escapeCart = function(e){
    		if((e.which || e.keyCode) === 27){ // allow user to close on escape
			hideCartView();
    		}
	},
	hideCartView = function() {
		var cartView = document.getElementsByClassName("cartsummary_view")[0];
		var cartSummary = document.getElementById("lnkCartSummary");
		//cartView.classList.remove('showing');  // is this needed?
		animate.slideUp(cartView);
		setTimeout(function(){
			//cartView.style.display = "none";
			cartSummary.setAttribute("aria-expanded", "false");			
		}, 200);
	},
	preventionKeys = function(e){
		e.preventDefault();
		e.stopPropagation();
	},
	cartKeys = function(){
		var cartSumLink = document.getElementById("lnkCartSummary");
		var checkoutLink = document.getElementById("checkoutLink");
		var cartDrop = document.getElementsByClassName("cartsummary_view")[0];
		var cartButtons = document.getElementsByClassName("cartsummary_buttons");
		var accountSumLink = document.getElementById("lnkAccountSummary");
		var showHideCart = function(){
			if(cartDrop.style.display == "block"){
		 		hideCartView(); 
		 	}else{ 
		 		showCartView();
		 		cartDrop.focus();
		 	}
		};
		
		if(cartSumLink){
			cartSumLink.addEventListener("keydown", function(e){
				if(e.which == 13){ //enter key
					preventionKeys(e);
				 	showHideCart();
				 }
				 if(e.altKey){ // alt + down arrow to open the menu (native control for accessing content via keyboard)
				 	if(e.which == 40){
				 		preventionKeys(e);
					 	showHideCart();
				 	}
				 }
			});
			
			checkoutLink.addEventListener("blur", function(){
				hideCartView(); 
			});
			Array.prototype.forEach.call(cartButtons, function(el, index, array){
				el.addEventListener("keydown", function(e){
					if ([38,40].indexOf(e.which) == -1) { return; } // if not down, up keys end here
					switch(e.which) {
						case 40: // down arrow
						case 38: // up arrow
							preventionKeys(e);
							hideCartView(); 
					}
				});
			});
		}
	},
	accountKeys = function(){
		//have to do these null checks because of the thirdparty stuff which hides the account menu
		var accountMenu = document.getElementById("accountMenu");
		var firstLink = accountMenu && accountMenu.getElementsByTagName("a") ? accountMenu.getElementsByTagName("a")[0] : null;
		var accountDropLinks = firstLink ? accountMenu.getElementsByTagName("a") : null;
		var accountSumLink = document.getElementById("lnkAccountSummary");
		
		var showHideAccount = function(){
			if(accountMenu.style.display == "block"){
				hideAccountView();
			}else{ 
				showAccountView(); 
				firstLink.focus();
			}
		};
		accountSumLink && accountSumLink.addEventListener("keydown", function(e){
			if(e.which == 13){ //enter key
				preventionKeys(e);
				showHideAccount();
			}
			if(e.altKey){ // alt + down arrow to open the menu (native control for accessing content via keyboard)
			 	if(e.which == 40){
			 		preventionKeys(e);
					showHideAccount();
			 	}
			 }
		});
		
		accountDropLinks && Array.prototype.forEach.call(accountDropLinks, function(el, index, array){
			el.addEventListener("keydown", function(e){
				if ([40, 38, 9].indexOf(e.which) == -1) { return; } // if not up, down and tab keys end here
				var lastLink = array[array.length -1];
				var nextLink = array[index + 1];
				var prevLink = array[index - 1];
				switch(e.which) {
					case 40: // down arrow
						preventionKeys(e);
						if(lastLink == document.activeElement){
				 			hideAccountView();
				 		}else{
				 			nextLink.focus();
				 		}
						break;
					case 38: // up arrow
						preventionKeys(e);
						if(accountDropLinks[0] == document.activeElement){
				 			hideAccountView();
				 		}else{
				 			prevLink.focus();
				 		}
						break;
					case 9: // tab
						preventionKeys(e);
						if(lastLink == document.activeElement){
				 			hideAccountView();
				 		}
				 		else {
				 			nextLink.focus();
				 		}
				}
			});
		});
	},
	addHeaderListeners = function(){
		if (mobileLink !== null){
			mobileLink.addEventListener("click", function () {
				var preferenceRequest = ajax({
					method: "GET",
					url: '/Header/UpdateMobilePreferences',
					timeout: 15000
				});
				preferenceRequest.then(function(response, xhr){
					return response;
				});
			});
		}
	},
	init = function(){
		loadUserLinks();
		loadCallStats();
		showMobileLink();
		addHeaderListeners();
	};
	
	return{
		loadUserLinks: loadUserLinks,
		init: init,
		init_cartsummary: init_cartsummary
	};
};